import { BikesType } from '@bikes/store/storeSlices/bikesDetails';
import {
  CallToActionCardProps,
  InformationBox,
  NavigationLinkObject,
} from '@molecules/*';
import { BeforeYouStartTemplate, ContentBody } from '@templates';

type HireContentProps = {
  bikesType: BikesType;
  contentTitle: string;
  callToActionCards: CallToActionCardProps[];
  linkObjectArrays: NavigationLinkObject[];
};

export const HireContent = ({
  bikesType,
  linkObjectArrays,
  callToActionCards,
  contentTitle,
}: HireContentProps) => {
  const contextLabel = {
    bikes: 'bike',
    hire_bikes: 'bike',
    hire_scooters: 'scooter',
  };

  const pluralContextLabel = {
    bikes: 'bikes',
    hire_bikes: 'bikes',
    hire_scooters: 'scooters',
  };

  const fixedPenaltyNoticeContent = (
    <>
      <p>
        Dockless bike companies are responsible for keeping the roads and
        pavements clear of obstructions caused by their bikes, and for managing
        the parking bays available across the city.
      </p>
      <br />
      <p>
        When you report a problem, we inform the bike operating company of the
        issue without sharing your personal information.
      </p>
      <br />
      <p>
        Our City Inspectors also receive the report and may decide to
        investigate further, particularly with persistent or repeated issues.
      </p>
    </>
  );

  const fpnContent = {
    extraInfo: fixedPenaltyNoticeContent,
  };

  const weAcceptContent = {
    sectionTitle: `We accept reports about ${pluralContextLabel[bikesType]} that:`,
    itemList: [
      `are not parked in an assigned bay`,
      `are parked dangerously. This means it could injure someone trying to walk or drive by, or it could cause damage to property`,
      'could be blocking the pavement or a doorway',
    ],
  };
  const needToKnowContent = {
    sectionTitle: `To help us resolve the issue, we need to know:`,
    itemList: [
      `details of the hire ${contextLabel[bikesType]} (such as brand and colour)`,
      `the location of the hire ${contextLabel[bikesType]} (include a door number or nearby landmarks like shops)`,
    ],
  };
  const helpfulToIncludeContent = {
    sectionTitle: `It’s useful to provide:`,
    itemList: ['photos of the issue', 'a photo of the QR code'],
  };

  const bodyContent = [
    fpnContent,
    weAcceptContent,
    needToKnowContent,
    helpfulToIncludeContent,
  ];

  return (
    <BeforeYouStartTemplate
      contentTitle={contentTitle}
      contentSubtext={
        <>
          <ContentBody content={bodyContent} />
          <InformationBox
            infoText={`We will pass your report to the hire ${contextLabel[bikesType]} company to action. Where appropriate, our City Inspectors will visit and will have the discretion to issue a Fixed Penalty Notice to the company.`}
            variant="info"
            data-testid="info-box"
          />
        </>
      }
      callToActionCards={callToActionCards}
      linkObjectArrays={linkObjectArrays}
    />
  );
};
